import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Divider, Grid, Link } from '@mui/material';
import { LeadIndustry, LeadRating, LeadSource, LeadStatus } from '../../../../utils/enums'
import { format } from 'date-fns';

const FullDetails = ({leadData}) => {
    return (
        <Accordion elevation={0} sx={{ borderRadius: '4px', '&:before': { height: '0px' } }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ margin: 0 }}>

                <h4>Details</h4>

            </AccordionSummary>
            <AccordionDetails
                sx={{ marginTop: '-17px' }}>
                <Divider />
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Lead Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>

                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Lead Owner</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.ownerName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Email</Typography></Grid>
                            <Grid item xs={8}><Link href="mailto:test@msn.com">{leadData?.email || '—'}</Link></Grid>
                            <Grid item xs={4}><Typography>Fax</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.fax || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Website</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.website || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Lead Status</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.leadStatus ? LeadStatus[leadData?.leadStatus].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>No. of Employees</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.numberOfEmployees || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Skype ID</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.skypeID || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Modified By</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.ownerName || '—'}<br />{leadData?.updatedAt ? format(new Date(leadData.updatedAt), 'MMMM do yyyy, h:mm:ss a') : '—'}
                            </Typography></Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Company</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.company || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Lead Name</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.firstName || '—'} {" " + leadData?.lastName || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Title</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.title || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Phone</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.phone || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Lead Source</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.leadSource ? LeadSource[leadData?.leadSource].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Industry</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.leadIndustry ? LeadIndustry[leadData?.industry].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Annual Revenue</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.annualRevenue || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Rating</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.rating ? LeadRating[leadData?.rating].label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Email Opt Out</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.emailOptOut || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Created By</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.ownerName || '—'}<br />{leadData?.createdAt ? format(new Date(leadData.createdAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Secondary Email</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.secondaryEmail || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Twitter</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.twitter || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Address Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Street</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.street || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>State</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.state || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Country</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.country || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>City</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.city || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Zip Code</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.zipCode || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Description Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Description</Typography></Grid>
                            <Grid item xs={8}><Typography>{leadData?.description || '—'}</Typography></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default FullDetails;